import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70c46af8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-admin" }
const _hoisted_2 = { class: "ho-app ho-app-admin" }
const _hoisted_3 = { class: "admin-nav flex w-full items-center" }
const _hoisted_4 = { class: "flex-none mr-8" }
const _hoisted_5 = { class: "flex flex-auto gap-x-6" }
const _hoisted_6 = { class: "w-8 h-8 text-center" }
const _hoisted_7 = { class: "admin-content" }

import IUser from '@/interfaces/users/iUser';
import { RouterView } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { HomeIcon } from '@heroicons/vue/outline';
import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Admin',
  props: {
	user: {
		type: Object as () => IUser,
	},
},
  setup(__props) {



const localization = useI18n();

const goToHome = () => router.push("/vat-explorer");

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(localization).t("app.administration")), 1),
        _createElementVNode("nav", _hoisted_5, [
          _createVNode(_component_router_link, {
            class: "admin-nav-link",
            to: { name: 'Users' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(localization).t("administration.users.title")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "admin-nav-link",
            to: { name: 'Organizations' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(localization).t("administration.organizations.title")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("button", {
          class: "btn flex",
          onClick: goToHome
        }, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_unref(HomeIcon), { class: "w-7 h-7" })
          ]),
          _createTextVNode(" " + _toDisplayString(_unref(localization).t("administration.home")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(RouterView), { user: __props.user }, null, 8, ["user"])
      ])
    ])
  ]))
}
}

})